export default __webpack_public_path__ + "static/media/project5.6e76d71f.png";